<template>
  <!-- ТЕСТОВАЯ СТРАНИЦА нового главного баннера. Адрес /preview/hero, закрыта от Google, в меню нет. -->
  <div class="pv-banner">
    <div class="container">Test page — new home banner. Variant 1 and Variant 2 below. Not visible in the site menu.</div>
  </div>

  <!-- ВАРИАНТ 1: заголовок над картинкой (как сейчас), поиск внутри картинки -->
  <div class="pv-label"><div class="container">Variant 1 — title above, search under the products</div></div>
  <section class="hero1">
    <div class="container">
      <div class="hero1__info">
        <h2>{{ home?.heroTitle || 'Wide selection of industrial automation and electronics components.' }}</h2>
        <p>{{ home?.heroText || 'We are your reliable partner for solving problems in the field of industrial automation.' }}</p>
      </div>
    </div>
    <div class="hero-img hero-img--v1" :style="{ backgroundImage: `url(${image})` }">
      <div class="container hero-img__inner">
        <form class="hs" @submit.prevent="go(q1)">
          <span class="hs__icon" aria-hidden="true">
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="21" fill="none"><g fill="#272930" opacity=".35"><path d="M0 8.18c0 4.53 3.722 8.178 8.342 8.178 4.62 0 8.342-3.649 8.342-8.179S12.962 0 8.342 0C3.722 0 0 3.65 0 8.18Zm8.342-5.034c2.823 0 5.133 2.265 5.133 5.033 0 2.768-2.31 5.033-5.133 5.033-2.824 0-5.134-2.265-5.134-5.033 0-2.768 2.31-5.033 5.134-5.033Z"/><path d="M15.012 11.257 22 18.108l-2.722 2.67-6.988-6.852 2.723-2.669Z"/></g></svg>
          </span>
          <input v-model="q1" type="text" placeholder="Search by part number, e.g. 6ES7153-1AA03-0XB0" aria-label="Search by part number"/>
          <button type="submit">Search</button>
        </form>
      </div>
    </div>
  </section>

  <!-- ВАРИАНТ 2: заголовок и поиск — оба внутри картинки -->
  <div class="pv-label"><div class="container">Variant 2 — title on the image, search under the products</div></div>
  <section class="hero-img hero-img--v2" :style="{ backgroundImage: `url(${image})` }">
    <div class="container hero-img__inner hero-img__inner--v2">
      <h1 class="hero2__title">{{ home?.heroTitle || 'Wide selection of industrial automation and electronics components.' }}</h1>
      <form class="hs" @submit.prevent="go(q2)">
        <span class="hs__icon" aria-hidden="true">
          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="21" fill="none"><g fill="#272930" opacity=".35"><path d="M0 8.18c0 4.53 3.722 8.178 8.342 8.178 4.62 0 8.342-3.649 8.342-8.179S12.962 0 8.342 0C3.722 0 0 3.65 0 8.18Zm8.342-5.034c2.823 0 5.133 2.265 5.133 5.033 0 2.768-2.31 5.033-5.133 5.033-2.824 0-5.134-2.265-5.134-5.033 0-2.768 2.31-5.033 5.134-5.033Z"/><path d="M15.012 11.257 22 18.108l-2.722 2.67-6.988-6.852 2.723-2.669Z"/></g></svg>
        </span>
        <input v-model="q2" type="text" placeholder="Search by part number" aria-label="Search by part number"/>
        <button type="submit">Search</button>
      </form>
    </div>
  </section>
  <div style="height: 60px"></div>
</template>

<script>
import {useSiteSettings} from "@/functions/siteSettings";
import heroImage from "@/assets/images/hero-new.jpg";

export default {
  setup() {
    return { home: useSiteSettings("home") };
  },
  data() {
    return { q1: "", q2: "", image: heroImage };
  },
  methods: {
    go(q) {
      this.$router.push({ name: "search", query: { str: q } });
    },
  },
};
</script>

<style scoped>
.pv-banner {
  background: #7bcfb7;
  color: #fff;
  font-family: "Circe-Bold", sans-serif;
  font-size: 13px;
  padding: 6px 0;
  text-align: center;
}
.pv-label {
  background: #f8f8f9;
  color: rgba(39, 41, 48, 0.6);
  font-family: "Circe-Bold", sans-serif;
  font-size: 14px;
  padding: 10px 0;
  border-top: 1px solid #ebedf2;
  border-bottom: 1px solid #ebedf2;
}

/* Вариант 1 — заголовок над картинкой, как сейчас */
.hero1__info {
  padding: 60px 0 40px;
}
.hero1__info h2 {
  font-size: 46px;
  line-height: 100%;
  margin-bottom: 26px;
  max-width: 620px;
}
.hero1__info p {
  font-size: 18px;
  line-height: 130%;
  max-width: 700px;
}

/* Картинка */
.hero-img {
  position: relative;
  background-size: cover;
  background-position: center bottom;
  background-repeat: no-repeat;
}
.hero-img--v1 {
  height: 680px;
}
.hero-img--v2 {
  height: 680px;
}
.hero-img__inner {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  padding-bottom: 70px;
}
.hero-img__inner--v2 {
  justify-content: space-between;
  padding-top: 56px;
}
.hero2__title {
  max-width: 820px;
  text-align: center;
  font-size: 44px;
  line-height: 1.08;
  margin-bottom: 30px;
  color: #272930;
}

/* Поиск внутри картинки */
.hs {
  display: flex;
  align-items: stretch;
  width: 100%;
  max-width: 820px;
  height: 64px;
  background: #fff;
  box-shadow: 0 14px 40px rgba(16, 25, 57, 0.14);
}
.hs__icon {
  display: flex;
  align-items: center;
  padding: 0 14px 0 22px;
}
.hs input {
  flex: 1;
  min-width: 0;
  border: none;
  font-size: 17px;
  color: #272930;
  background: transparent;
}
.hs input:focus {
  outline: none;
}
.hs button {
  flex: none;
  padding: 0 38px;
  border: none;
  background: #6083c0;
  color: #fff;
  font-family: "Circe-Bold", sans-serif;
  font-size: 18px;
  cursor: pointer;
  transition: background 0.18s ease;
}
.hs button:hover {
  background: #4f72b0;
}
.hs__hint {
  margin-top: 14px;
  font-size: 14px;
  color: rgba(39, 41, 48, 0.6);
}

@media (max-width: 1199px) {
  .hero-img--v1 {
    height: 560px;
  }
  .hero-img--v2 {
    height: 560px;
  }
}
@media (max-width: 767px) {
  .hero1__info {
    padding: 36px 0 24px;
  }
  .hero1__info h2 {
    font-size: 26px;
    margin-bottom: 14px;
  }
  .hero1__info p {
    font-size: 14px;
  }
  .hero-img {
    background-position: 58% bottom;
  }
  .hero-img--v1 {
    height: 380px;
  }
  .hero-img--v2 {
    height: 420px;
  }
  .hero-img__inner {
    padding-bottom: 24px;
  }
  .hero-img__inner--v2 {
    padding-top: 22px;
  }
  .hero2__title {
    font-size: 24px;
    margin-bottom: 16px;
  }
  .hs {
    height: 52px;
  }
  .hs__icon {
    padding: 0 8px 0 14px;
  }
  .hs input {
    font-size: 14px;
  }
  .hs button {
    padding: 0 18px;
    font-size: 15px;
  }
  .hs__hint {
    font-size: 12px;
    text-align: center;
  }
}
</style>
